import React from 'react'
import ExperiencePage from '../Pages/ExperiencePage'

export default function Experience() {
  return (
    <section id="experience" className="section experience">
      <h2 className="section-title">Experience</h2>
      <div className="section-content">
        <ExperiencePage />
      </div>
    </section>
  )
}


